import React from 'react';
import { MeatballMenu, ButtonCallToAction, ButtonTertiary, PromptConfirmationModal } from 'ui';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import * as navigate from 'app/area/shared/navigation';
import { routeConstants } from 'app/routes/route-constants';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { TextConfigurationTranslation } from '../../constants';
import { isCustomerTextSet } from '../utils/is-customer-text-set';
import { TextConfigurationItem, TextConfigurationItemTranslation } from '../types-store';
import { replaceTemplateString } from 'app/infrastructure/platform';
import styles from './text-form-sticky-header.scss';

export interface TextFormStickyHeaderProps {
  textItem: TextConfigurationItem;
  language: TextConfigurationItemTranslation;
  development: boolean;
  shouldPrompt: boolean;
  disabled: boolean;
  onSave: () => void;
  onDelete: () => void;
  translation: TextConfigurationTranslation;
}

export const TextFormStickyHeader: React.FC<TextFormStickyHeaderProps> = ({
  textItem, language, development, shouldPrompt, disabled, onSave, onDelete, translation
}) => {

  const updatingTextItem = isDefinedIncludingZero(textItem?.id);
  const canDelete = updatingTextItem && (!!development ||
    isCustomerTextSet(textItem));

  const onCancel = () => {
    navigate.to({ pathname: routeConstants.textConfigurationList });
  };

  return <StickyHeader rightSideContent={<>
    <StickyHeaderButtonContainer>
      <ButtonTertiary
        id="text-form-sticky-header-cancel-button"
        onClick={onCancel}>
        {translation.cancel}
      </ButtonTertiary>
      <ButtonCallToAction
        id="text-form-sticky-header-save-button"
        onClick={onSave}
        disabled={!shouldPrompt}>
        {translation.save_text_button}
      </ButtonCallToAction>
    </StickyHeaderButtonContainer>
    {canDelete && <MeatballMenu id="text-form-sticky-header-meatballmenu">
      <li>
        <PromptConfirmationModal
          title={translation.delete_text_title}
          description={replaceTemplateString(translation.delete_text_confirm, language?.text)}
          continueText={translation.delete_text_button}
          cancelText={translation.cancel}
          onContinue={onDelete}>
          <button type="button" className="dropdown-item" disabled={disabled}>
            {translation.delete_text_button}
          </button>
        </PromptConfirmationModal>
      </li>
    </MeatballMenu>}
  </>}>
    {updatingTextItem && textItem?.textSet?.description
      ? <div className={styles.headerTextset}>
        {textItem.textSet.description}
      </div>
      : null}
    <div className={styles.headerContainer}>
      {updatingTextItem ? <span className={styles.headerId}>
        #{textItem.id}
      </span> : null}
      <h2 className={styles.headerTitle}>
        {updatingTextItem
          ? language?.text || null
          : translation.new_text}
      </h2>
    </div>
  </StickyHeader>;
};
